<oph-page-header
  [title]="'People'"
  [description]="'Manage your users'"
  [primaryActionButtonText]="'Add Person'"
  [primaryActionButtonIcon]="'plus-white'"
  (primaryActionButtonChange)="addUser()"
  (searchInputChange)="onSearchChange($event)"
/>
